module.exports = __webpack_public_path__ + "img/newpagebg3.64c7c653.jpg";